import React, { useState, useEffect, useCallback } from "react";
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../../auth/registered/SEC_00_DB_Payload";
// 🎯 FIX: Alias to UserView (PascalCase)
import UserView from "./SEC_03_UserManagementView"; 

export default function SEC_03_UserManagementController() {
  const [users, setUsers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🎯 FIX: Wrapped in useCallback to satisfy useEffect dependency rule
  const loadUsers = useCallback(async (term = "") => {
    setIsSubmitting(true);
    try {
      const siteKey = process.env.REACT_APP_SITE_KEY;
      const response = await dbPayload(
        "/api/v1/sustina/manage-users/search", 
        "POST", 
        siteKey, 
        { SearchTerm: term }
      );

      const normalized = GoldenSourceHelper.normalize(response);
      setUsers(normalized.data || []);
    } catch (err) {
      console.error("❌ User search failed:", err);
      setUsers([]);
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  useEffect(() => { 
    loadUsers(); 
  }, [loadUsers]); // 🎯 FIX: loadUsers added as dependency

  return <UserView users={users} isSubmitting={isSubmitting} onSearch={loadUsers} />;
}